export const parseBoolean = (val) => {
  if (Array.isArray(val)) {
    if (val.length === 0) return "";
    val = val[0];
  }

  if (!val) return "";

  if (val === "S") return true;
  if (val === "N") return false;

  return "";
};
